module.exports = __webpack_public_path__ + "283c8431b8a40b98af2a8b2381045379.png";